// internal
import { AccountType } from '@app/store/typings/actions/account.d';
import { AccountState } from '@app/store/typings/state/account.d';

const initState: AccountState = {
  login: {
    isFailed: false,
    message: '',
  },
  isPopup: false,
  isPasswordReset: false,
  resetpassword: {
    email: '',
  },
  emailCheck: {
    isLoading: false,
    isSuccess: false,
    isFailed: false,
    message: 'accounts.register.email_required',
  },
  phoneCheck: {
    isLoading: false,
    isSuccess: false,
    isFailed: false,
    message: 'accounts.register.phone_required',
  },
  dataForm: {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    phoneNumber: '',
    password: '',
    emailRef: '',
    emailSessionId: '',
    phoneRef: '',
    phoneSessionId: '',
  },
  validateStatus: {
    isLoading: false,
    emailSuccess: false,
    emailFailed: false,
    phoneSuccess: false,
    phoneFailed: false,
    createUser: false,
    createFailed: false,
  },
  isAccountAlreadyRegistered: false,
};

export const account = (state = initState, action: AccountType) => {
  switch (action.type) {
    case 'KEY_ACCOUNT_LOGIN_CLEAR':
      state.login.isFailed = false;
      state.login.message = '';
      return { ...state };
    case 'KEY_ACCOUNT_REGISTER_CLEAR':
      state.validateStatus = {
        isLoading: false,
        emailSuccess: false,
        emailFailed: false,
        phoneSuccess: false,
        phoneFailed: false,
        createUser: false,
        createFailed: false,
      };
      return { ...state };
    case 'KEY_ACCOUNT_LOGIN_FETCH':
      return { ...state, messageLogin: '' };
    case 'KEY_ACCOUNT_TOGGLE_POPUP':
      state.isPopup = !state.isPopup;
      return { ...state };
    case 'KEY_ACCOUNT_PASSWORDRESET_POPUP':
      state.isPasswordReset = !state.isPasswordReset;
      return { ...state };
    case 'KEY_ACCOUNT_POPUP_CLEAR':
      state.isPopup = false;
      state.isPasswordReset = false;
      return { ...state };
    case 'KEY_ACCOUNT_LOGIN_INCORRECT':
      state.login.isFailed = true;
      state.login.message = action.payload.message;
      return { ...state };
    case 'KEY_ACCOUNT_EMAIL_AVAILABILITY':
      state.emailCheck.isLoading = true;
      return { ...state };
    case 'KEY_ACCOUNT_EMAIL_AVAILABILITY_SUCCESS':
      state.emailCheck.isLoading = false;
      state.emailCheck.isSuccess = true;
      state.emailCheck.isFailed = false;
      return { ...state };
    case 'KEY_ACCOUNT_EMAIL_AVAILABILITY_FAILED':
      state.emailCheck.isLoading = false;
      state.emailCheck.isSuccess = false;
      state.emailCheck.isFailed = true;
      state.emailCheck.message = action.payload.message;
      return { ...state };
    case 'KEY_ACCOUNT_PHONE_AVAILABILITY':
      state.phoneCheck.isLoading = true;
      return { ...state };
    case 'KEY_ACCOUNT_PHONE_AVAILABILITY_SUCCESS':
      state.phoneCheck.isLoading = false;
      state.phoneCheck.isSuccess = true;
      state.phoneCheck.isFailed = false;
      return { ...state };
    case 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED':
      state.phoneCheck.isLoading = false;
      state.phoneCheck.isSuccess = false;
      state.phoneCheck.isFailed = true;
      state.phoneCheck.message = action.payload.message;
      return { ...state };
    case 'KEY_ACCOUNT_SET_DATAFORM':
      state.dataForm.username = action.payload.username;
      state.dataForm.firstName = action.payload.firstName;
      state.dataForm.phoneNumber = action.payload.phoneNumber;
      state.dataForm.lastName = action.payload.lastName;
      state.dataForm.email = action.payload.email;
      state.dataForm.password = action.payload.password;
      return { ...state };
    case 'KEY_ACCOUNT_SET_EMAIL_SESSION':
      state.dataForm.emailRef = action.payload.emailRef;
      state.dataForm.emailSessionId = action.payload.emailSessionId;
      return { ...state };

    case 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP':
      state.validateStatus.isLoading = true;
      return { ...state };
    case 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_SUCCESS':
      state.validateStatus.isLoading = false;
      state.validateStatus.emailSuccess = true;
      state.validateStatus.emailFailed = false;
      state.validateStatus.isLoading = false;
      state.validateStatus.phoneFailed = false;
      state.validateStatus.createUser = true;
      state.validateStatus.createFailed = false;

      return { ...state };
    case 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_FAILED':
      state.validateStatus.isLoading = false;
      state.validateStatus.emailFailed = true;
      return { ...state };
    case 'KEY_ACCOUNT_SET_PHONE_SESSION':
      state.dataForm.phoneRef = action.payload.phoneRef;
      state.dataForm.phoneSessionId = action.payload.phoneSessionId;
      return { ...state };
    case 'KEY_ACCOUNT_VALIDATE_PHONE_OTP':
      state.validateStatus.isLoading = true;
      return { ...state };
    case 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_SUCCESS':
      state.validateStatus.isLoading = false;
      state.validateStatus.emailSuccess = false;
      state.validateStatus.emailFailed = false;
      state.validateStatus.isLoading = false;
      state.validateStatus.phoneSuccess = true;
      state.validateStatus.phoneFailed = false;
      state.validateStatus.createUser = true;
      state.validateStatus.createFailed = false;
      return { ...state };
    case 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED':
      state.validateStatus.isLoading = false;
      state.validateStatus.phoneFailed = true;
      return { ...state };
    case 'KEY_ACCOUNT_CREATE_SUCCESS':
      state.validateStatus.isLoading = false;
      state.validateStatus.phoneFailed = false;
      state.validateStatus.createUser = true;
      state.validateStatus.createFailed = false;
      return { ...state };
    case 'KEY_ACCOUNT_CREATE_FAILED':
      state.validateStatus.isLoading = false;
      state.validateStatus.createFailed = true;
      return { ...state };
    case 'KEY_ACCOUNT_PASSWORDRESET_OTP_SUCCESS':
      state.resetpassword.email = action.payload;
      return { ...state };
    case 'KEY_VALIDATE_INVITE_PHONE':
      state.validateStatus.isLoading = true;
      return { ...state };
    case 'KEY_INVITEE_REGISTERED':
      state.isAccountAlreadyRegistered = true;
      return { ...state };
    case 'KEY_CLEAR_AVAILABLE_STATUS':
      state.emailCheck.isFailed = false;
      state.phoneCheck.isFailed = false;
      return { ...state };
    default:
      return state;
  }
};
